export default {
  images: {
    logo: require("../../src/assets/images/logo.png"),
    roundIcon: require("../../src/assets/images/splashIcon.png"),
    dentalidLogo: require("../../src/assets/images/dentalidLogo.png"),
    placholderCanvas: require("../../src/assets/images/placholderCanvas.png"),
    applogo: require("../../src/assets/images/app-logo.png"),
    refrenceLineArea: require("../../src/assets/images/refrenceLineArea.jpg"),
    logoDentalid: require("../../src/assets/images/logoDentalid.svg"),
    cloudBased: require("../../src/assets/images/cloudBased.png"),
    signUpCloud: require("../../src/assets/images/signupCloud.png"),
    forgetPasswordCloud: require("../../src/assets/images/forget-password.png"),
    recaptcha: require("../../src/assets/images/recaptcha.png"),
  },
  icons: {
    lineMeasurementIcon: require("../../src/assets/images/lineMeasurementIcon.png"),
    areaMeasurementIcon: require("../../src/assets/images/areaMeasurementIcon.png"),
    measureBackgroundIcon: require("../../src/assets/images/measureBackgroundIcon.png"),
    uploadImageIcon: require("../../src/assets/icons/uploadImageIcon.png"),
    dentelidIcon: require("../../src/assets/icons/dentelidIcon.png"),
    zoomIcon: require("../../src/assets/icons/zoomIcon.png"),
    colorIcon: require("../../src/assets/icons/colorIcon.png"),
    contrastIcon: require("../../src/assets/icons/contrastIcon.png"),
    newImageIcon: require("../../src/assets/icons/newImageIcon.png"),
    rotateIcon: require("../../src/assets/icons/roatateIcon.png"),
    roatateRightIcon: require("../../src/assets/icons/roatateRightIcon.png"),
    measurementIcon: require("../../src/assets/icons/measurementIcon.png"),
    newImage: require("../../src/assets/icons/newImage.png"),
    rotateright: require("../../src/assets/icons/rotateright.png"),
    rotateleft: require("../../src/assets/icons/rotateleft.png"),
    move: require("../../src/assets/icons/move.png"),
    zoomin: require("../../src/assets/icons/zoomin.png"),
    zoomout: require("../../src/assets/icons/zoomout.png"),
    downArrow: require("../../src/assets/icons/downArrow.png"),
    left: require("../../src/assets/icons/left.png"),
    down: require("../../src/assets/icons/down.png"),
    up: require("../../src/assets/icons/up.png"),
    right: require("../../src/assets/icons/right.png"),
    refrencelineIcon: require("../../src/assets/icons/refrence-line.png"),
    measurelineIcon: require("../../src/assets/icons/measure-line.png"),
    moveActive: require("../../src/assets/icons/moveActive.png"),
    rotateActive: require("../../src/assets/icons/rotateActive.png"),
    zoomActive: require("../../src/assets/icons/zoomActive.png"),
    invert: require("../../src/assets/icons/invert.png"),
    clear: require("../../src/assets/icons/clear.png"),
    guidHorizontal: require("../../src/assets/icons/guidHorizontal.png"),
    guidVertical: require("../../src/assets/icons/guidvertical.png"),
    guidLines: require("../../src/assets/icons/guidLines.png"),
    resetPolygon: require("../../src/assets/icons/resetPolygon.png"),
    refrenceRuler: require("../../src/assets/icons/refrenceRuler.png"),
    drawPolygon: require("../../src/assets/icons/drawPolygon.png"),
    password: require("../../src/assets/loigin/password.png"),
    hidenPassword: require("../../src/assets/icons/hide_password.png"),
    showPassword: require("../../src/assets/icons/show-password-icon.png"),
    email: require("../../src/assets/loigin/email.png"),
    DentaliD: require("../../src/assets/loigin/DentaliD.png"),
    Dentalid_logo: require("../../src/assets/loigin/dental_id_logo.png"),
    toplogo: require("../../src/assets/icons/toplogo.svg"),
    contrast: require("../../src/assets/icons/contrast.png"),
    sharpen: require("../../src/assets/icons/sharpen.png"),
    overlay: require("../../src/assets/icons/overlay.png"),
    yellowLine: require("../../src/assets/icons/yellow-line.png"),
    angelMeasurement: require("../../src/assets/icons/angelMeasurement.png"),
    measureLength: require("../../src/assets/icons/measure-length.png"),
    textIcon: require("../../src/assets/icons/text_icon.png"),
    settingIcon: require("../../src/assets/icons/settings-icon.png"),
    userAccount: require("../../src/assets/icons/userAccount-icon.png"),
    measureMentArea: require("../../src/assets/icons/measureMent-area.png"),
    cardItems: require("../../src/assets/icons/cardItems.png"),
    rightArrow: require("../../src/assets/icons/right-arrow.png"),
    measureArea: require("../../src/assets/icons/measure-area.png"),
    AreaAi: require("../../src/assets/icons/area-ai.png"),
    AgeAssessment: require("../../src/assets/icons/age-assessment.png"),
    speciality: require("../../src/assets/icons/speciality.png"),
    successIcon: require("../../src/assets/icons/success-icon.png"),
    cancelIcon: require("../../src/assets/icons/cancel-icon.png"),
    alertTriangleIcon: require("../../src/assets/icons/alert-triangle.png"),
    countryIcon: require("../../src/assets/icons/country-icon.png"),
    dentistIcon: require("../../src/assets/icons/dentist-icon.png"),
    licenseIcon: require("../../src/assets/icons/license-icon.png"),
  },
  colors: {
    lightGrey: "#414D55",
  },
};
